import { render, staticRenderFns } from "./RegisterDocument.vue?vue&type=template&id=dc58caec&scoped=true"
import script from "./RegisterDocument.vue?vue&type=script&lang=js"
export * from "./RegisterDocument.vue?vue&type=script&lang=js"
import style0 from "./RegisterDocument.vue?vue&type=style&index=0&id=dc58caec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc58caec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VCol,VImg,VLayout,VRow})
